import {random,part, s, p, execute} from './scripting.js';
import {preventIntersect, circle} from './structure.js';
import {slice, proportion} from './proportion.js';
import {none} from './none.js';
import {getScriptForTitleSync} from 'decentralized/scripting/scripting.js';
import {getDiameter, getCentroid} from './geometry.js';
import {lazy} from './lazy.js';
import {WIDTH, HEIGHT} from 'components/effects/plane/constants.js';
import {spread} from './spread.js';
import {fluid} from './navier-preset.js';
import {navierStokes} from './navier-stokes.js';
import {mac} from './mac.js';
import {and, or, neq, gte, lte, eq, cond} from './flow.js';
import {diff} from './diff.js';
import {source} from './source.js';
import {loop} from './loop.js';
import {interpolateSnapshot, nextSnapshot, snapshot} from './snapshot.js';
import {rewind, reset} from './time.js';
import {search, byDevice, not} from './search.js';
import {send, receive} from './msg.js';
import {translate} from './translate.js';
import {bounce} from './bounce.js';
import {vectorField} from './vector-fields.js';
import {slow, clear} from './density.js';
import {
    swap,
    life,
    expand,
    rotate} from './operations.js';
import {altn, alt, every} from './alt.js';
import {beat} from './beat.js';

export default superclass => class extends superclass  {

    code = "";
    script = undefined;
    forces = {};

    eval(code) {
        let values = this.clearVariables();
        this.code = code;
        this.script = this.evalWithContext(code);

        for (let name in values) {
            if (this[name + 'Parameter']) {
                this[name + 'Parameter'].copyFrom(
                    values[name], this.track.sequencerEngine);
            }
        }
        this.updateVariablesRedux();
    }

    hasSyntaxError(str) {
        return this.evalWithContext(str) === undefined;
    }

    restartScript() {
        if (this.code === "") {
            return;
        }
        this.eval(this.code);
    }

    evalWithContext(str) {
        try {
            let pieces = str.split(";");
            let last = pieces[pieces.length - 1];
            let preamble = pieces.slice(0, pieces.length - 1).join(";");
            let code = "with(this) { " + preamble + "; return s(" + last + ")}";
            let knob = (name, val, min=0, max=100, hide=false) => {
                let v = this.newVar(name, val, min, max, undefined, hide);
                return () => this[name+'Parameter'].get();
            };

            return (new Function(code)).call({
                rotate,
                translate,
                s,
                random,
                fluid,
                circle,
                every,
                none,
                altn,
                loop,
                snapshot,
                byDevice,
                spread,
                life,
                send,
                rewind,
                lazy,
                proportion,
                slice,
                preventIntersect,
                gte,
                lte,
                eq,
                neq,
                diameter: getDiameter,
                geometry: getCentroid,
                diff,
                and,
                or,
                reset,
                alt,
                slow,
                clear,
                navierStokes,
                swap,
                beat,
                bounce,
                vectorField,
                expand,
                search,
                p,
                part,
                interpolateSnapshot,
                nextSnapshot,
                load: (name) => this.loadScript(name),
                receive,
                sin: Math.sin,
                cos: Math.cos,
                tan: Math.tan,
                source,
                cond,
                mac,
                not,
                WIDTH,
                HEIGHT,
                knob,
                force: (n=this.variables.length) => {
                    let force = [
                        knob(`force.x ${n}`, 10*n, 0, WIDTH, true),
                        knob(`force.y (${n})`, 10*n, 0, HEIGHT, true),
                        knob(`force.dx (${n})`, 100, -WIDTH, WIDTH, true),
                        knob(`force.dy (${n})`, 100, -HEIGHT, HEIGHT, true),
                    ];
                    this.forces = {
                        ... this.forces
                    };
                    this.forces[n] = this.variables.slice(
                        this.variables.length - 4);
                    return force;
                },
                diffusion: () => knob("diffusion", 0.75, 0.7, 1.2)
            });
        } catch (e) {
            console.log('error = ', e);
            return undefined;
        }
    }

    knob(name, val, min=0, max=100, hide=false) {
        let v = this.newVar(name, val, min, max, undefined, hide);
        return () => this[name+'Parameter'].get();
    }

    force(n=this.variables.length)  {
        let knob = (name, val, min=0, max=100, hide=false) => {
            let v = this.newVar(name, val, min, max, undefined, hide);
            return () => this[name+'Parameter'].get();
        };

        let force = [
            knob(`force.x ${n}`, 10*n, 0, WIDTH, true),
            knob(`force.y (${n})`, 10*n, 0, HEIGHT, true),
            knob(`force.dx (${n})`, 100, -WIDTH, WIDTH, true),
            knob(`force.dy (${n})`, 100, -HEIGHT, HEIGHT, true),
        ];
        this.forces = {
            ... this.forces
        };
        this.forces[n] = this.variables.slice(
            this.variables.length - 4);
        return force;
    }

    loadScript(name) {
        let code = getScriptForTitleSync(name);
        let ctxt = this.evalWithContext(code, false);
        return () => ctxt; 
    }


}
